import axios from "axios";

export const NOTICES_URL = `${process.env.REACT_APP_API_URL}/notices`;

// READ
export function FindNotices(queryParams) {
  return axios.get(NOTICES_URL, {
    params: {
      pageSize: queryParams.pageSize,
      pageNumber: queryParams.pageNumber,
      ...queryParams.filter
    },
  });
}

export function GetNoticeById(noticeId) {
  return axios.get(`${NOTICES_URL}/${noticeId}`);
}

// CREATE
export function CreateNotice(notice) {
  return axios.post(NOTICES_URL, notice);
}

// DELETE
export function DeleteNotice(noticeId) {
  return axios.delete(`${NOTICES_URL}/${noticeId}`);
}

// EDIT
export function EditNotice({ id, name, description }) {
  return axios.put(`${NOTICES_URL}`, {
    id: id,
    name: name,
    description: description,
    type: 0,
    branchId: id,
  });
}
